<template>
  <div class="dashboard_content">
    <div class="dashboardContact">
      <h1 class="contentTitle">連絡先</h1>
      <div class="contact_informationMessage" v-html="name"></div>
      <div class="contact_informationMessage" v-html="address"></div>
      <div class="contact_informationMessage" v-html="information"></div>
      <div class="contact_informationIndent">
        よくある問い合わせについては、こちらをご確認ください。<br />
        <a href="https://carerings.com/support/" target="_blank"
          >https://carerings.com/support/</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contactInfo: Object
  },
  computed: {
    name() {
      const header = '連絡先名：'
      if (this.contactInfo != null) {
        return header + this.contactInfo.name
      }
      return header
    },
    address() {
      const header = '電話番号：'
      if (this.contactInfo != null) {
        return header + this.contactInfo.address
      }
      return header
    },
    information() {
      const header = '受付時間：'
      if (this.contactInfo != null) {
        return header + this.contactInfo.information
      }
      return header
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/dashboardContact.vue